import { Component, HostBinding, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonDataService } from '../../Common/common-data.service';
import { DataService } from '../../service/data.service';
import { HierarchyService } from '../../service/hierarchy.service';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css'],
})
export class LoginComponent implements OnInit {
  simpleForm: FormGroup;
  societyId: string;
  showCollectionPointInfo: boolean = false;
  submitted = false;
  formErrors: any;
  showModal: boolean;
  registerForm: FormGroup;
  entryForm: FormGroup;

  @HostBinding('class') cAppClass = 'c-app flex-row align-items-center';

  login: any = {
    collectionpoint_id: '',
    password: ''
  };

  Otp: any = {};
  newOtp: any = {};
  newOtp1: any = {};
  otp1: any = {};
  verifyotp: any = {};

  showErrorMessage  = false;
  showErrorMessage1 = false;
  showOTPModal:  boolean;
  showOTPModal1: boolean;
  showOTPModal2: boolean;
  showModal3:    boolean;

  forgotPassword: any = {};
  Customer: any;

  constructor(
    private fb: FormBuilder,
    private service: DataService,
    private commonData: CommonDataService,
    private router: Router,
    private route: ActivatedRoute,
    private hierarchyService: HierarchyService
  ) { }

  ngOnInit(): void {
    // If already logged in, skip straight to dashboard
    if (sessionStorage.getItem('isLoggedIn') === 'true') {
      this.router.navigate(['/dashboard']);
      return;
    }

    this.route.queryParams.subscribe(params => {
      if (params['returnUrl']) {
        console.log('Returning from protected route:', params['returnUrl']);
      }
    });
  }

  get f() { return this.simpleForm.controls; }

  onReset() {
    this.submitted = false;
    this.simpleForm.reset();
  }

  onValidate() {
    this.submitted = true;
    return this.simpleForm.status === 'VALID';
  }

  createForm() {
    this.simpleForm = this.fb.group({
      countryCode: ['', [Validators.required]],
      mobileNo:    ['', [Validators.required]],
    });
  }

  onSubmit() {
    if (this.onValidate()) {
      console.warn(this.simpleForm.value);
    }
  }

  // ══════════════════════════════════════════════════════════════════════════
  // LOGIN
  // ══════════════════════════════════════════════════════════════════════════

  onLogin() {
    this.showErrorMessage        = false;
    this.showCollectionPointInfo = false;

    const loginCredentials = {
      username: this.login.collectionpoint_id,
      password: this.login.password
    };

    this.service.login(loginCredentials).subscribe(
      (resp: any) => {
        console.log('Login Response:', resp);

        if (resp && resp.status === 200) {
          // ── 1. Mark as logged in ───────────────────────────────────────
          sessionStorage.setItem('isLoggedIn', 'true');

          // ── 2. Store user data from response ──────────────────────────
          if (resp.data) {
            const d = resp.data;

            sessionStorage.setItem('userName',             d.name            || '');
            sessionStorage.setItem('mobileNumber',         d.mobileNumber    || '');
            sessionStorage.setItem('empId',                d.empId           ? d.empId.toString()           : '');
            sessionStorage.setItem('dairyId',              d.dairyId         ? d.dairyId.toString()         : '');
            sessionStorage.setItem('dairyName',            d.dairyName       || '');
            sessionStorage.setItem('roleId',               d.roleId          ? d.roleId.toString()          : '');
            sessionStorage.setItem('roleName',             d.roleName        || '');
            sessionStorage.setItem('societyId',            d.societyId       ? d.societyId.toString()       : '');
            sessionStorage.setItem('societyName',          d.societyName     || '');
            sessionStorage.setItem('collectionPointId',    d.collectionPointId ? d.collectionPointId.toString() : '');
            sessionStorage.setItem('collectionPointName',  d.collectionPointName || '');
            sessionStorage.setItem('userData',             JSON.stringify(d));

            // Store in CommonDataService
            this.commonData.societyId           = d.societyId         ? d.societyId.toString() : '';
            this.commonData.collectionpoint_id  = d.collectionPointId;
            this.commonData.collectionpoint_name = d.collectionPointName;

            this.societyId               = d.societyId ? d.societyId.toString() : '';
            this.showCollectionPointInfo = true;

            // ── 3. Fetch & store hierarchy, then navigate ──────────────
            const empId = d.empId;

            if (empId) {
              this.service.getHierarchy(empId).subscribe(
                (hierarchyResp: any) => {
                  console.log('Hierarchy Response:', hierarchyResp);

                  if (hierarchyResp && hierarchyResp.status === 200 && hierarchyResp.data) {
                    // ✅ Single place for all hierarchy processing — the service
                    this.hierarchyService.storeHierarchyData(hierarchyResp.data);
                    console.log('Hierarchy stored. Access level:', this.hierarchyService.getUserAccessLevel());
                  } else {
                    console.warn('Hierarchy API returned no data:', hierarchyResp);
                    localStorage.setItem('userHierarchy', JSON.stringify([]));
                  }

                  this.router.navigate(['dashboard']);
                },
                (hierarchyError) => {
                  console.error('Error fetching hierarchy:', hierarchyError);
                  localStorage.setItem('userHierarchy', JSON.stringify([]));
                  this.router.navigate(['dashboard']);
                }
              );
            } else {
              console.warn('No empId in login response — skipping hierarchy fetch');
              this.router.navigate(['dashboard']);
            }
          }

        } else {
          this.showErrorMessage = true;
          console.error('Login failed:', resp?.msg || 'Invalid credentials');
        }
      },
      (error) => {
        this.showErrorMessage = true;
        console.error('Login error:', error);
      }
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // LOGOUT
  // ══════════════════════════════════════════════════════════════════════════

  logout() {
    // Clear session storage
    [
      'isLoggedIn', 'collectionpoint_id', 'societyId', 'userName',
      'mobileNumber', 'empId', 'dairyId', 'dairyName', 'roleId',
      'roleName', 'societyName', 'collectionPointId', 'collectionPointName', 'userData'
    ].forEach(key => sessionStorage.removeItem(key));

    // Clear hierarchy data via service (single responsibility)
    this.hierarchyService.clearHierarchyData();

    // Clear CommonDataService
    this.commonData.collectionpoint_id   = null;
    this.commonData.societyId            = null;
    this.commonData.collectionpoint_name = null;

    this.router.navigate(['/login']);
  }

  // ══════════════════════════════════════════════════════════════════════════
  // FORGOT PASSWORD FLOW
  // ══════════════════════════════════════════════════════════════════════════

  onforgotPassword(Otp: any) {
    this.showErrorMessage1 = false;
    console.log(this.Otp.countryCode, this.Otp.mobileNo);

    this.service.forgotPassword(this.Otp).subscribe((resp: any) => {
      console.log('forgotPassword Response:', JSON.stringify(resp));
      if (resp && resp.statusCode === 200) {
        this.showOTP1();
      } else {
        this.showErrorMessage1 = true;
      }
    });
  }

  onverifyotp(Otp: any) {
    this.newOtp1.mobileNo = this.Otp.mobileNo;
    this.newOtp1.otp      = this.Otp.otp;
    this.showErrorMessage = false;

    this.service.verifyotp(this.newOtp1).subscribe((resp: any) => {
      console.log('verifyotp Response:', JSON.stringify(resp));
      if (resp && resp.status === 200) {
        this.showOTP2();
      } else {
        this.showErrorMessage = true;
      }
    });
  }

  onnewpassword() {
    this.newOtp.mobileNo    = this.Otp.mobileNo;
    this.newOtp.newPassword = this.Otp.newPassword;
    this.newOtp.otp         = Number(this.Otp.otp);
    this.showErrorMessage   = false;

    this.service.newpassword(this.newOtp).subscribe((resp: any) => {
      console.log('newpassword Response:', JSON.stringify(resp));
      if (resp && resp.status === 200) {
        this.show();
        this.router.navigate(['login']);
      } else {
        this.showErrorMessage = true;
      }
    });
  }

  getCollectionPointDisplay(): string {
    if (this.showCollectionPointInfo && this.commonData.collectionpoint_id && this.societyId) {
      return `${this.commonData.collectionpoint_id}+${this.societyId}=${this.commonData.collectionpoint_id}${this.societyId}`;
    }
    return '';
  }

  // ── Modal helpers ──────────────────────────────────────────────────────────
  showOTP()  { this.showOTPModal  = true;  }
  hideOTP()  { this.showOTPModal  = false; }
  showOTP1() { this.showOTPModal1 = true;  }
  hideOTP1() { this.showOTPModal1 = false; }
  showOTP2() { this.showOTPModal2 = true;  }
  hideOTP2() { this.showOTPModal2 = false; }
  show()     { this.showModal3    = true;  }
  close()    { this.showModal3    = false; }
  refreshPage() { window.location.reload(); }
}

// ── Interfaces ─────────────────────────────────────────────────────────────

export interface newotp {
  mobileNo: number;
  otp: number;
  newPassword: string;
}

export interface LoginResponse {
  status: number;
  msg: string;
  data: {
    name: string;
    mobileNumber: string;
    empId: number;
    dairyId: number;
    dairyName: string;
    roleId: number;
    roleName: string;
    societyId: number;
    societyName: string;
    collectionPointId: number;
    collectionPointName: string;
  };
}

export interface LoginCredentials {
  username: string;
  password: string;
}